import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ImageWrapper = styled.div`
	margin-bottom: 1.5rem;
`;

export const OneImageWrapper = styled.div`
	
`;

export const SmallImageWrapper = styled.div`
	width: 100%;
	img {
		width: 100%;
		height: auto;
	}
`;

export const UlWrapper = styled.div``;
